import Vue from "vue";
import Storage from "vue-web-storage";
import Loading from "vue-loading-overlay";
import moment from "moment";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n/i18n";
import { VueMasonryPlugin } from "vue-masonry";
import SpinnerService from "./services/spinner/spinner-service";
import { $httpService } from "./services/httpService";
import { contrastService } from "./services/contrastService";
import { fontSizeService } from "./services/fontSizeService";

import Vuetify, {
  VApp,
  VAvatar,
  VToolbar,
  VToolbarItems,
  VBtn,
  VToolbarTitle,
  VSpacer,
  VFooter,
  VToolbarSideIcon,
  VContainer,
  VLayout,
  VFlex,
  VCard,
  VCardTitle,
  VCardText,
  VImg,
  VIcon,
  VNavigationDrawer,
  VList,
  VListTile,
  VListTileContent,
  VListTileTitle,
  VDivider
} from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import "vue-loading-overlay/dist/vue-loading.css";
import "vuetify/src/stylus/app.styl";
import "./styles/index.scss";
import globalStyle from "./styles/_global.scss";

Vue.config.productionTip = false;

Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "$http", { value: $httpService });
Object.defineProperty(Vue.prototype, "$contrast", { value: contrastService });
Object.defineProperty(Vue.prototype, "$fontSize", { value: fontSizeService });
Object.defineProperty(Vue.prototype, "$spinner", { value: SpinnerService });

Vue.use(Vuetify, {
  components: {
    VApp,
    VAvatar,
    VToolbar,
    VToolbarItems,
    VBtn,
    VToolbarTitle,
    VSpacer,
    VFooter,
    VToolbarSideIcon,
    VContainer,
    VLayout,
    VFlex,
    VCard,
    VCardTitle,
    VCardText,
    VImg,
    VIcon,
    VNavigationDrawer,
    VList,
    VListTile,
    VListTileContent,
    VListTileTitle,
    VDivider
  },
  iconfont: "md"
});

Vue.use(Storage, {
  prefix: process.env.VUE_APP_LOCAL_STORAGE_PREFIX
});

Vue.use(Loading, {
  opacity: 1,
  loader: "bars",
  height: 200,
  width: 200,
  color: globalStyle.accentColor
});

Vue.use(VueMasonryPlugin);

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
